export const AddressKinds = {
    DELIVERY_ADDRESS: 1,
    INVOICE_ADDRESS: 2,
    DELIVERY_AND_INVOICE_ADDRESS: 3,
    INACTIVE_ADDRESS: 4
};

export const AddressKindLabels = {
    [AddressKinds.DELIVERY_ADDRESS]: {
        en: 'Delivery address',
        nl: 'Bezorgadres'
    },
    [AddressKinds.INVOICE_ADDRESS]: {
        en: 'Invoice address',
        nl: 'Factuuradres'
    },
    [AddressKinds.DELIVERY_AND_INVOICE_ADDRESS]: {
        en: 'Delivery and invoice address',
        nl: 'Bezorg- en factuuradres'
    },
    [AddressKinds.INACTIVE_ADDRESS]: {
        en: 'Inactive address',
        nl: 'Inactief adres'
    }
};

// Helper functie
export function getAddressKindLabel(kind, language = 'nl') {
    return AddressKindLabels[kind]?.[language] || 'Unknown';
}